export default __webpack_public_path__ + "static/media/145198.1c1606d2.jpg";